import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';

import { components } from 'react-select';

const ContactSelectMenuEmptyState = props => (
  <components.Menu {...props}>
    <div className="empty-state px-4 py-5">
      <h1 className="icons mt-0 text-muted">
        <FontAwesomeIcon className="mr-4" icon={faUser} />
        <FontAwesomeIcon icon={faBriefcase} />
      </h1>

      <div className="description mb-4">
        {props.description}
      </div>

      <div className="controls">
        <a aria-label="new" className="clickable" onClick={props.selectProps.onCreateClick}>
          + Create new {props.selectProps.contactTypeLabel}
        </a>
      </div>
    </div>
  </components.Menu>
);

ContactSelectMenuEmptyState.propTypes = {
  description: PropTypes.string.isRequired,
  selectProps: PropTypes.shape({
    contactTypeLabel: PropTypes.string.isRequired,
    onCreateClick: PropTypes.func.isRequired
  })
};

export default ContactSelectMenuEmptyState;
